import React, { createContext, useContext, useEffect, useState } from 'react'
import {
  getDatabase,
  ref,
  onValue,
  child,
  off,
  set,
  DatabaseReference
} from 'firebase/database'
import { IChatNotification } from 'types'
import Storage from 'storage/auth'
import { databaseUrl, firebaseApp } from 'firebaseConfig'
import dayjs from 'dayjs'

export type ChatNotifications = {
  [key: string]: IChatNotification
} & {
  created_at: dayjs.Dayjs
}

type IFirebaseData = {
  chatNotifications?: ChatNotifications
  readMessage?: (chatId: string) => Promise<void>
}

const FirebaseListenerContext = createContext<IFirebaseData>(
  {} as IFirebaseData
)

const FirebaseListenerProvider: React.FC<React.PropsWithChildren> = ({
  children
}) => {
  const [chat, setChat] = useState<ChatNotifications>({} as ChatNotifications)
  const [mensagem, setMensagem] = useState<IFirebaseData>({} as IFirebaseData)
  const [dataBaseRef, setDataBaseRef] = useState<DatabaseReference>()
  const user = Storage.user.get()

  useEffect(() => {
    const readMessage = async (chatId: string) => {
      if (dataBaseRef && chat) {
        if (chat[chatId] != null) {
          const chatRef = child(
            dataBaseRef,
            `chat_notifications/${chatId}/count`
          )
          set(chatRef, 0)
          off(chatRef)
        }
      }
    }
    setMensagem({ chatNotifications: chat, readMessage })
  }, [chat])

  useEffect(() => {
    const db = ref(getDatabase(firebaseApp(), databaseUrl()))

    const notificationRef = child(db, `notifications/${user?.professional_id}`)

    setDataBaseRef(notificationRef)

    const unsubscribe = onValue(notificationRef, snapshot => {
      if (snapshot.exists()) {
        const data = snapshot.val()
        setChat(data.chat_notifications)
      }
    })

    return () => {
      off(db)
      off(notificationRef)
      unsubscribe()
    }
  }, [])

  return (
    <FirebaseListenerContext.Provider value={mensagem}>
      {children}
    </FirebaseListenerContext.Provider>
  )
}

export function useFirebaseListener() {
  return useContext(FirebaseListenerContext)
}

export default FirebaseListenerProvider
